import React, { ChangeEvent } from 'react';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';

interface Props {
    name: string;
    value: string | number | null;
    options: Array<{value: string | number, label: string}>;
    placeholder?: string;
    hint?: string;
    empty?: string;
    isClearable?: boolean;
    required?: boolean;
    onChangeHandler: (value: string | number | null, name: string) => void;

}

interface State {
    value: string | number | null;
}

class InputSelect<T> extends React.Component<Props & InjectedIntlProps, State> {

    public state = {
        value: null,
    };

    public componentDidMount() {
        this.setState({value: this.props.value});
    }

    public componentWillReceiveProps(props: Props) {
        this.setState({value: props.value});
    }

    public render() {
        return (
            <>
                <select
                    name={this.props.name}
                    value={this.state.value || ''}
                    onChange={(e: ChangeEvent<HTMLSelectElement>) => { this.props.onChangeHandler(e.currentTarget.value || null, this.props.name); }}
                    className="form-control"
                >
                    {(this.props.isClearable || !this.props.required) && <option value=''>{this.props.empty || 'Összes'}</option>}
                    {this.props.options.map(({value, label}) => (
                        <option key={value} value={value}>{label}</option>
                    ))}
                </select>
                {this.props.hint && <span className="form-text m-b-none">{this.props.hint}</span>}
            </>
        );
    }
}

export default compose(
    injectIntl,
)(InputSelect);



// WEBPACK FOOTER //
// ./src/components/Form/InputSelect.tsx